import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router';
import notification from 'antd/es/notification';

import { PathCreator, RoutePaths } from '../constants';
import { getProfileState } from 'models/profile/selectors';

import type { RouteProps } from 'react-router';
import type { SystemRolesType } from 'models/profile/types';

interface IPermissionRouteProps extends RouteProps {
  permissions?: SystemRolesType[];
  auth?: boolean;
}

export const PermissionRoute: React.FC<IPermissionRouteProps> = ({ permissions, auth, ...routeProps }: IPermissionRouteProps) => {
  const currentUser = useSelector(getProfileState);
  const correctPermission = permissions && permissions.includes(currentUser.role);
  const correctAuth = auth && currentUser.sub;

  if (!(auth || permissions) ||
    (correctPermission && !auth) ||
    (correctAuth && !permissions) ||
    (correctAuth && correctPermission)
  ) {
    return <Route {...routeProps} />
  }

  notification.warn({
    message: 'You are not authorized or there is no access!',
    placement: 'topRight',
  });

  return <Redirect to={PathCreator[RoutePaths.AUTH_LOGIN].path} />
};
